var indentation_default = {
  "indentZero": "SISpo",
  "indentOne": "vkkMO",
  "indentTwo": "AMjGo",
  "indentThree": "eXJJ4",
  "indentFour": "ik-0p",
  "indentFive": "HuCPZ",
  "indentSix": "tBG3t"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
